export default "__VITE_ASSET__0847d1cf__"